/**
 * The two caller-verification scopes a tool can run under. Shared by the tool form (which sets
 * a tool's required scope) and the test runner (which simulates a caller scope) so the option
 * labels and meanings never drift between them.
 */

export const BASE_SCOPE = 'partner_user';
export const VERIFIED_SCOPE = 'partner_user:verified';
export type ToolScope = typeof BASE_SCOPE | typeof VERIFIED_SCOPE;

export const TOOL_SCOPE_OPTIONS: { value: ToolScope; label: string }[] = [
  { value: BASE_SCOPE, label: 'Unverified caller (partner_user)' },
  { value: VERIFIED_SCOPE, label: 'Verified caller (partner_user:verified)' },
];

/** Coerce a stored required_scope string to a known option (anything else falls back to base). */
export const normalizeToolScope = (scope: string | undefined): ToolScope =>
  scope === VERIFIED_SCOPE ? VERIFIED_SCOPE : BASE_SCOPE;
